import axios from 'axios';

export async function getCityLeaguesList(city_pk) {
  const res = await axios({
    method: 'GET',
    url:
      process.env.REACT_APP_API_URL +
      `/api/configuration/cities/${city_pk}/leagues/`,
  });

  if (res.status === 200) {
    return res.data;
  } else {
    return { error: res.status };
  }
}

